import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import IClerkResponse from "@/types/clerk";

export default {
  namespaced: true,
  state: {} as IClerkResponse,
  actions,
  getters,
  mutations,
};
